<template>
  <div>
    <form @submit.prevent="uploadFile">
      <input type="file" @change="onFileChange" />
      <button 
        type="submit"
        :disabled="!this.selectedFile"
      >
        Upload File
      </button>
    </form>
    <div v-if="fileUrl">File URL: <a :href="fileUrl" target="_blank">{{ fileUrl }}</a></div>
    <div v-if="fileUrl">
      <img :src="fileUrl" alt="awas file">      
    </div>
  </div>
</template>


<script>


// GLOBALS
// ----------------
const API = process.env.VUE_APP_API_URL;
let FLA_AXIOS
// ----------------


export default {
  name:'AWS_Uploader',
  components: {},
  props:{
    userId: String,
    uploadCb: Function,
  },
  data() {
    return {
      fileUrl: '',
      selectedFile: null,
    }
  },
  computed: {},
  methods: {
    onFileChange(event) {
      this.selectedFile = event.target.files[0]; // Store the selected file
    },

    async uploadFile() {

      // this should never happen but just in case
      if (!this.selectedFile) {
        alert("Please choose a file first.");
        return;
      }

      // create form data
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('userId', this.userId);


      try {
        // manually control backdrop since we are sending special headers
        window.ShowBackdrop();

        // TODO: see if we can do this with FLA_AXIOS
        const response = await this.axios.post(API + '/api/user/uploadLogo', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.fileUrl = response.data.presignedUrl;

        // call CB to reload page information
        this.uploadCb();
      } 
      catch (error) {
        console.error('Error uploading file:', error);
      }
      window.HideBackdrop();
    },

  },
  mounted(){
    FLA_AXIOS = window.FLA_Axios;
  }
}
</script>


<style>

</style>